import type { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { pointerEventsStyles, theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const Container = (props: PropsWithChildren) => {
  return <View style={[styles.container, pointerEventsStyles['box-none']]}>{props.children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'flex-end',
    paddingTop: theme.spacing['2'],
  },
});
